import type { ReactElement } from "react";
import CardPost from "../../../../../components/posts/post-types/card/card-post";
import CommentPost from "../../../../../components/posts/post-types/comment/comment-post";
import GameEventPost from "../../../../../components/posts/post-types/game-event/game-event-post";
import GoalPost from "../../../../../components/posts/post-types/goal/goal-post";
import KeyMomentPost from "../../../../../components/posts/post-types/key-moment/key-moment-post";
import PollPost from "../../../../../components/posts/post-types/poll/poll-post";
import PollResultPost from "../../../../../components/posts/post-types/poll-result/poll-result-post";
import StandardPost from "../../../../../components/posts/post-types/standard/standard-post";
import { type Post, PostType } from "../../../../../types/post.types";

export const getPostItem = (post: Post): ReactElement => {
	if (post.type === PostType.VAR || post.type === PostType.PENALTY) {
		return <GameEventPost key={post.id} post={post} />;
	}

	if (post.type === PostType.KEY_MOMENT) {
		return <KeyMomentPost key={post.id} post={post} />;
	}

	if (post.type === PostType.CARD) {
		return <CardPost key={post.id} post={post} />;
	}

	if (post.type === PostType.FAN_COMMENT) {
		return <CommentPost key={post.id} post={post} />;
	}

	if (post.type === PostType.GOAL) {
		return <GoalPost key={post.id} post={post} />;
	}

	if (post.type === PostType.POLL) {
		return <PollPost key={post.id} post={post} />;
	}

	if (post.type === PostType.POLL_RESULT) {
		return <PollResultPost key={post.id} post={post} />;
	}

	switch (post.type) {
		default:
			return <StandardPost key={post.id} post={post} />;
	}
};
